import { useMemo } from "react";
import { IStyleSet, mergeStyleSets } from "@fluentui/react/lib/Styling";
import { useTheme } from "@fluentui/react/lib/Theme";

export function useCenterStyles(styleSet: IStyleSet) {
  const { semanticColors } = useTheme();
  return useMemo(
    () => mergeStyleSets(
      {
        mainContainer: {
          backgroundColor: semanticColors.bodyBackground,
          padding: `0 18px`,
          height: `100%`,
          width: `100%`,
          maxWidth: `2560px`
        },
        centerContainer: {
          backgroundColor: semanticColors.bodyBackground,
          display: `flex`,
          justifyContent: `center`,
          textAlign: `center`,
          height: `100%`
        }
      },
      styleSet
    ),
    [semanticColors, styleSet]
  );
}
